import { IconButton, Tooltip } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import useAuthentication from "../hooks/useAuthentication";
import useGoToLogin from "../hooks/useGoToLogin";
import { trackEvent } from "../utility/analytics";
import {
  buildSmsUrl,
  buildWhatsAppUrl,
  canSendSms,
} from "../utility/messaging";

// Pre-order "Message shop" button, mirroring the mobile app's product page and
// storefront. `shop` must be the full customer shop DTO (GET /shop/:shopId),
// not a product's trimmed shop populate: the message number and
// contactPreferences only live on the full one, and the number is only sent
// to logged-in viewers. Logged-out viewers still see the button so it can
// prompt a login, after which the shop query refetches with the number.
const MessageShopButton = ({ shop, message, source }) => {
  const { isLoggedIn, currentUser } = useAuthentication();
  const goToLogin = useGoToLogin();

  if (!shop) return null;
  const allowsMessages = shop.contactPreferences?.allowPreOrderMessages ?? true;
  const isOwnShop = !!currentUser?.id && currentUser.id === shop.owner?.id;
  if (!allowsMessages || shop.status === "CLOSED" || isOwnShop) return null;

  const phone = shop.messagePhoneNumber;
  const isWhatsapp = shop.messagePhoneIsWhatsapp ?? false;
  if (isLoggedIn && (!phone || (!isWhatsapp && !canSendSms()))) return null;

  const handleClick = () => {
    if (!isLoggedIn) {
      goToLogin();
      return;
    }
    trackEvent("shop_messaged", {
      shopId: shop.id,
      channel: isWhatsapp ? "whatsapp" : "sms",
      source,
    });
    if (isWhatsapp) {
      window.open(
        buildWhatsAppUrl(phone, message),
        "_blank",
        "noopener,noreferrer",
      );
    } else {
      window.location.href = buildSmsUrl(phone, message);
    }
  };

  return (
    <Tooltip title={isWhatsapp ? "Message shop on WhatsApp" : "Message shop"}>
      <IconButton
        size="small"
        onClick={handleClick}
        aria-label="Message shop"
        sx={{ color: "#046287" }}
      >
        <ChatBubbleOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default MessageShopButton;
